export default "__VITE_ASSET__C4U9G5_9__"